import AppRouter from 'app/router/ui/AppRouter';
import classes from './AppLayout.module.scss';
import { theme as antdTheme } from 'antd';

const AppLayout = () => {
  const {
    token: { colorBgBase },
  } = antdTheme.useToken();
  return (
    <div className={classes.wrapper} style={{ backgroundColor: colorBgBase }}>
      <AppRouter />
    </div>
  );
};

export default AppLayout;
